export interface IVoucherSimulationConfig {
    growthVariability: number,
    growthRateRapidGrowthDecline: number[],
    growthRateMostLikely: number[],
    growthRateSlowGrowth: number[],
    growthRateSlowGrowthDecline: number[],
    eligibilityForTransplant: number[],
    mortalityRisk: number[],
    esrdRisk: number[]
}